<template>
  <div id="user-edit-tab-info">
    <div id="studentCreateLoadingDiv" class="vs-con-loading__container">
      <form>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <vs-input class="w-full mt-4" label="First Name" v-model="data_local.name" v-validate="'required|alpha_spaces'" name="name" />
            <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>
          </div>

          <div class="vx-col md:w-1/2 w-full">
            <vs-input class="w-full mt-4" label="Last Name" v-model="data_local.last_name" v-validate="'required|alpha_spaces'" name="last_name" />
            <span class="text-danger text-sm"  v-show="errors.has('last_name')">{{ errors.first('last_name') }}</span>
          </div>
        </div>

        <div class="vx-row mb-base">
          <div class="vx-col md:w-1/2 w-full">
            <vs-input class="w-full mt-4" label="Email" v-model="data_local.email" type="email" v-validate="'required|email'" name="email" />
            <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
          </div>

          <div class="vx-col md:w-1/2 w-full">
            <vx-input-group class="">
              <template slot="prepend">
                <div class="mt-10 prepend-text bg-primary">
                  <span>+45</span>
                </div>
              </template>

              <vs-input class="w-full mt-4" label="Phone" v-model="data_local.phone" type="phone" v-validate="'required|numeric|digits:8'" name="phone" />
            </vx-input-group>
              <span class="text-danger text-sm"  v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
          </div>
        </div>

        <div class="vx-row mb-base">
          <div class="vx-col md:w-1/2 w-full">
            <datepicker placeholder="Date of birth" format="yyyy-MM-dd" v-validate="'required'" name="dob" ref="dob" v-model="data_local.dob"></datepicker>
            <span class="text-danger text-sm"  v-show="errors.has('dob')">{{ errors.first('dob') }}</span>
          </div>

          <div class="vx-col md:w-1/2 w-full mt-2">
            <vs-radio class="mr-2" v-model="data_local.gender" vs-value="male">Male</vs-radio>
            <vs-radio class="mr-2" v-model="data_local.gender" vs-value="female">Female</vs-radio>
            <vs-radio class="mr-2" v-model="data_local.gender" vs-value="non_binary">Non binary</vs-radio>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            Package
            <v-select v-model="selectedPackage" :options="optionPackages" :dir="$vs.rtl ? 'rtl' : 'ltr'" /><br>
          </div>

          <div class="vx-col md:w-1/2 w-full ">
            
          </div>
        </div>

        <vs-divider/>

        <div class="vx-row mb-base">
          <div class="vx-col md:w-1/2 w-full">
            <vs-input class="w-full mt-4" type="password" label="Password" v-validate="'required|min:6|max:20'" name="password" ref="password" v-model="data_local.password"  />
            <span class="text-danger text-sm"  v-show="errors.has('password')">{{ errors.first('password') }}</span>
          </div>

          <div class="vx-col md:w-1/2 w-full">
            <vs-input class="w-full mt-4" type="password" label="Confirm Password" v-validate="'required|min:6|max:12|confirmed:password'" name="confirm_password" ref="confirm_password" v-model="data_local.confirm_password"  />
            <span class="text-danger text-sm"  v-show="errors.has('confirm_password')">{{ errors.first('confirm_password') }}</span>
          </div>
        </div>

        <!-- Save & Reset Button -->
        <div class="vx-row" >
          <div class="vx-col w-full" align="right">
            <vs-button class="ml-4" type="border" color="warning" @click="reset_data">Reset</vs-button>
            <vs-button class="ml-4" @click="validateCreateUserForm" :disabled="!validateForm">Save Changes</vs-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
import modulePackageManagement from '@/store/package-management/modulePackageManagement.js'

export default {
  components: {
    vSelect,
    Datepicker,
  },
  data() {
    return {
      data_local : {
        name : null,
        last_name : null,
        email : null,
        phone : null,
        password : null,
        confirm_password : null,
        gender : 'male',
        role : 'student',
        dob : null,
      },
      selectedPackage : null,
      optionPackages : [],
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any()
    }
  },
  methods: {
    capitalize(str) {
      return str.slice(0,1).toUpperCase() + str.slice(1,str.length)
    },
    getDateString(date) {
      const d = new Date(date);
      const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
      const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
      const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
      return (`${ye}-${mo}-${da}`);
    },
    validateCreateUserForm() {
      this.$validator.validateAll().then(result => {
        if (result) this.create_user()
        else{
          
        }
      })
    },
    save_changes() {
      if(!this.validateForm) return
    },
    reset_data() {
      this.selectedPackage = null
      this.data_local = JSON.parse(JSON.stringify({}))
    },
    create_user() {
      this.$vs.loading({
          container: '#studentCreateLoadingDiv',
          scale: 0.6
      })

      let userData = this.data_local
      userData.dob = this.getDateString(this.data_local.dob)
      userData.package_id = (this.selectedPackage == null) ? null : this.selectedPackage.id

      this.$store.dispatch("userManagement/createStudents", userData)
        .then(res => { 
            this.$vs.loading.close('#studentCreateLoadingDiv > .con-vs-loading')

            this.$vs.notify({
                title: "Success.",
                text: "Student created successfully.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success"
            });

            if(res.status == 201){
              this.$router.push("/students/" + res.data.user.id).catch(() => {})
            }
        })
        .catch(err => { 
          if(err.status && err.status == 422){
            Object.keys(err.data).forEach(function(key) {
              self.errors.add({
                field: key,
                msg: err.data[key][0],
              });
            });
          }

          this.$vs.loading.close('#studentCreateLoadingDiv > .con-vs-loading')
        })
    },
    getAllPackages() {
      this.$store.dispatch("packageManagement/getAllPackages")
        .then(res => { 
          let optionPackages = []
          res.data.forEach(function(entry, key) {
            optionPackages.push({
              id : entry.id,
              label : entry.name+" ("+entry.cost+" $)",
            })
          });

          this.optionPackages = optionPackages
        })
        .catch(err => { 
            
        })
    },
  },
  created() {
    if(!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }

    if(!modulePackageManagement.isRegistered) {
        this.$store.registerModule('packageManagement', modulePackageManagement)
        modulePackageManagement.isRegistered = true
    }

    this.getAllPackages()
  }
}
</script>
